import React from "react";
import style from "./style.scss";

export const MenuHeading = ({ label }) => {
    return <span className={style.heading}>{label}</span>;
};
